import { useState } from "react";
import { Button, Modal, Spin, Tooltip } from "antd";
import { InfoCircleOutlined, LinkOutlined } from "@ant-design/icons";
import { useAppDispatch } from "../../../hooks/reduxHooks";
import { notifyBrokenLinkApi } from "../../../services/skincare.service";

const DetailPopup = ({ item, noImage }: any) => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Button className="buy-btn" type="primary" onClick={showModal}>
        Your Guide
      </Button>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        width={850}
        centered
        wrapClassName="custom-modal"
      >
        <div className="item skincare-solution-modal">
          <div className="img-holders">
            <div className="image-wrapper">
              <img
                src={item.image ?? noImage}
                alt={item?.name}
              />
              <h3 className="title">{item.name}</h3>
            </div>
            <div className="content">
            <div
  dangerouslySetInnerHTML={{ __html: item.description }}
/>
            </div>
          </div>
          <div className="btn-groups">
            {item &&
              item?.store_info?.map((buyHereItem: any, i: any) => {
                return (
                  <div style={{ maxWidth: "200px" }}>
                    <Button
                      href={buyHereItem.url}
                      target="_blank"
                      key={i + "__"}
                    >
                      <span>{buyHereItem.name}</span>
                    </Button>
                    {buyHereItem?.care_code && (
                      <div className="care-text">
                        * {buyHereItem?.care_code}&nbsp;
                        <div className="care-tooltip">
                          <InfoCircleOutlined />
                          <span className="care-title">
                            Use this Care Code during checkout to get discount.
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DetailPopup;
